import { render, staticRenderFns } from "./pcBalanceHeader.vue?vue&type=template&id=e5c53c9c&scoped=true"
import script from "./pcBalanceHeader.vue?vue&type=script&lang=js"
export * from "./pcBalanceHeader.vue?vue&type=script&lang=js"
import style0 from "./pcBalanceHeader.vue?vue&type=style&index=0&id=e5c53c9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c53c9c",
  null
  
)

export default component.exports